var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div> <div id="setting_margin" class="setting_margin"> <div id="module_margin" class="div100"> <div id="empty" class="empty"> </div> </div> </div> </div>';
}
return __p;
};
